export function DoCalculateLayout(branchMgr, rootNode, pageAuxLines, chartType) {
  if (branchMgr) {
    branchMgr.CalculatePageLayout(rootNode, pageAuxLines, chartType);
  }
}
